import { hasPermission } from '@/hooks/useBackendMenu'
import { notasAdesivas, type Registro } from 'service/api'
import { formatarDia } from './notas-adesivas-digitacao'
import { NotasAdesivasPopover } from './notas-adesivas-popover'

/**
 * Notas do registro no modal de detalhes. Busca por conta própria: o modal
 * abre também fora da Digitação, sem as notas da grade em contexto.
 * Não renderiza sem permissão de leitura nem para registro excluído.
 */
export function NotasAdesivasDetalhesRegistro({
    registro,
}: {
    registro: Registro
}) {
    const canLerNotas = hasPermission(['read', 'NotasAdesivas'])
    const isExcluido = Boolean(registro.deletedAt)
    const { data: notas = [] } = notasAdesivas.useFetch({
        queryParams: { registroId: registro.id },
        enabled: canLerNotas && !isExcluido,
    })

    if (!canLerNotas || isExcluido) return null

    return (
        <NotasAdesivasPopover
            // Tipado como `Date`, mas chega da API como string ISO.
            titulo={`${formatarDia(String(registro.data))} | ${registro.hora}`}
            ancora={{ registroId: registro.id }}
            notas={notas}
            variant="static"
            isModal
        />
    )
}
